'use strict';

module.exports = function (ngModule) {
    ngModule.directive('alertMessage', require('./alert'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/alert/index.js
 **/